/** Hand-drawn marker-style doodle pack inspired by classic kids colouring books.
 *  Bold outlines, flat marker fills, slight wobble. Use sparingly across the site
 *  to add personality without dominating the layout. */

export const Frog = ({ size = 80, className = "", color = "#8BC547" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.4" strokeLinejoin="round" strokeLinecap="round">
      <ellipse cx="50" cy="60" rx="32" ry="26" fill={color} />
      <circle cx="34" cy="30" r="10" fill={color} />
      <circle cx="66" cy="30" r="10" fill={color} />
      <circle cx="34" cy="30" r="4" fill="#fff" />
      <circle cx="66" cy="30" r="4" fill="#fff" />
      <circle cx="34" cy="30" r="2.2" fill="#2C2C2A" />
      <circle cx="66" cy="30" r="2.2" fill="#2C2C2A" />
      <path d="M40 65 Q50 73 60 65" />
      <path d="M22 75 Q18 88 28 88" />
      <path d="M78 75 Q82 88 72 88" />
    </g>
  </svg>
);

export const Flower = ({ size = 70, className = "", color = "#F2C84B", center = "#DD2E20" }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2" strokeLinejoin="round">
      <circle cx="40" cy="14" r="11" fill={color} />
      <circle cx="14" cy="40" r="11" fill={color} />
      <circle cx="66" cy="40" r="11" fill={color} />
      <circle cx="40" cy="66" r="11" fill={color} />
      <circle cx="22" cy="22" r="10" fill={color} />
      <circle cx="58" cy="22" r="10" fill={color} />
      <circle cx="22" cy="58" r="10" fill={color} />
      <circle cx="58" cy="58" r="10" fill={color} />
      <circle cx="40" cy="40" r="11" fill={center} />
    </g>
  </svg>
);

export const Crayon = ({ size = 60, className = "", color = "#F4C734" }) => (
  <svg width={size} height={size * 0.35} viewBox="0 0 100 36" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2" strokeLinejoin="round">
      <path d="M14 6 L86 6 L92 18 L86 30 L14 30 Z" fill={color} />
      <path d="M86 6 L92 18 L86 30" />
      <line x1="24" y1="6" x2="24" y2="30" />
      <path d="M86 6 L94 18 L86 30" fill="#2C2C2A" opacity="0.05" />
    </g>
  </svg>
);

export const MusicNote = ({ size = 50, className = "", color = "#DD2E20" }) => (
  <svg width={size} height={size} viewBox="0 0 60 60" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.4" strokeLinejoin="round" strokeLinecap="round">
      <ellipse cx="18" cy="44" rx="10" ry="8" transform="rotate(-15 18 44)" fill={color} />
      <ellipse cx="44" cy="38" rx="10" ry="8" transform="rotate(-15 44 38)" fill={color} />
      <path d="M27 38 L27 8 L53 4 L53 32" fill="none" />
    </g>
  </svg>
);

export const Bird = ({ size = 80, className = "", color = "#A9CDE5" }) => (
  <svg width={size} height={size * 0.7} viewBox="0 0 100 70" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round">
      <path d="M20 40 Q14 20 36 18 Q56 8 72 22 Q92 24 88 42 Q76 56 56 56 Q34 58 20 40 Z" fill={color} />
      <path d="M72 22 L92 14 L84 28" fill={color} />
      <circle cx="76" cy="32" r="2.2" fill="#2C2C2A" />
      <path d="M86 38 L98 38" />
      <path d="M84 42 L96 44" />
      <path d="M40 56 L42 64 M52 56 L52 66 M64 56 L66 64" />
    </g>
  </svg>
);

export const Butterfly = ({ size = 80, className = "", colorA = "#F0A8C3", colorB = "#A9CDE5" }) => (
  <svg width={size} height={size * 0.8} viewBox="0 0 100 80" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.2" strokeLinejoin="round">
      <ellipse cx="30" cy="28" rx="22" ry="20" fill={colorA} />
      <ellipse cx="70" cy="28" rx="22" ry="20" fill={colorB} />
      <ellipse cx="30" cy="60" rx="18" ry="14" fill={colorA} />
      <ellipse cx="70" cy="60" rx="18" ry="14" fill={colorB} />
      <line x1="50" y1="14" x2="50" y2="72" />
      <path d="M50 14 Q45 4 40 6" />
      <path d="M50 14 Q55 4 60 6" />
    </g>
  </svg>
);

export const Heart = ({ size = 60, className = "", color = "#DD2E20" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} fill="none" aria-hidden>
    <path d="M32 56 C8 40 8 22 20 18 C28 16 32 24 32 24 C32 24 36 16 44 18 C56 22 56 40 32 56 Z" fill={color} stroke="#2C2C2A" strokeWidth="2.4" strokeLinejoin="round" />
  </svg>
);

export const Lightning = ({ size = 50, className = "", color = "#F4C734" }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" className={className} fill="none" aria-hidden>
    <path d="M28 4 L8 30 L20 30 L18 46 L40 18 L28 18 Z" fill={color} stroke="#2C2C2A" strokeWidth="2.2" strokeLinejoin="round" />
  </svg>
);

export const Ice = ({ size = 70, className = "", color = "#F0A8C3" }) => (
  <svg width={size} height={size * 1.25} viewBox="0 0 60 75" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round">
      <path d="M14 32 Q14 8 30 8 Q46 8 46 32 Z" fill={color} />
      <line x1="30" y1="32" x2="30" y2="58" />
      <path d="M26 58 L34 58 L32 68 L28 68 Z" fill="#F4C734" />
    </g>
  </svg>
);

export const Scribble = ({ w = 120, className = "", color = "#F4C734" }) => (
  <svg className={className} width={w} height={w * 0.5} viewBox="0 0 120 60" fill="none" aria-hidden>
    <path d="M6 30 Q14 6 24 30 T44 30 T64 30 T84 30 T104 30 T118 30" stroke={color} strokeWidth="8" strokeLinecap="round" fill="none" opacity="0.85"/>
  </svg>
);

export const Spiral = ({ size = 50, className = "", color = "#DD2E20" }) => (
  <svg width={size} height={size} viewBox="0 0 60 60" className={className} fill="none" aria-hidden>
    <path d="M30 30 m -1 0 a 1 1 0 1 1 2 0 a 5 5 0 1 1 -6 4 a 10 10 0 1 1 12 -8 a 16 16 0 1 1 -20 12" stroke={color} strokeWidth="3.5" fill="none" strokeLinecap="round" />
  </svg>
);

export const Trumpet = ({ size = 70, className = "", color = "#F4C734" }) => (
  <svg width={size} height={size * 0.55} viewBox="0 0 100 55" className={className} fill="none" aria-hidden>
    <g stroke="#2C2C2A" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round">
      <path d="M4 28 L60 28 L88 6 L88 50 L60 28 Z" fill={color} />
      <circle cx="22" cy="28" r="3" fill="#2C2C2A" />
      <circle cx="36" cy="28" r="3" fill="#2C2C2A" />
      <circle cx="50" cy="28" r="3" fill="#2C2C2A" />
    </g>
  </svg>
);
